import React, { ButtonHTMLAttributes, FC, ReactNode, useContext } from 'react';
import { styled } from 'linaria/react';
import { segmentedControlItemBorderRadiusesPx, segmentedControlItemBorderRadiusesRem, segmentedControlItemHeightPx, segmentedControlItemHeightRem, segmentedControlItemIconSizesPx, segmentedControlItemIconSizesRem, segmentedControlItemIconWrapperSizesPx, segmentedControlItemIconWrapperSizesRem, segmentedControlSizes } from '@shared/config/components/segmentedControl';
import { withTheme } from '@shared/lib/theme';
import { useBreakpoint } from '@shared/lib/react';
import { Text } from '@shared/ui/atoms';
import { getSegmentedControlItemTextSize } from '@shared/lib/components/getSegmentedControlItemTextSize';
import { SegmentedControlContext } from './SegmentedControlContext';
type SizeValue = keyof typeof segmentedControlSizes;
export interface SegmentedControlItemType {
  icon?: ReactNode;
  label: string;
}
interface SegmentedControlItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  label: string;
  index?: number;
  isLastElem?: boolean;
  onItemClick?: (index: number) => void;
}
const SegmentedControlItem: FC<SegmentedControlItemProps> = ({
  icon,
  label,
  index = 0,
  isLastElem,
  onItemClick,
  ...rest
}) => {
  const {
    size,
    activeItemIndex,
    setActiveItemIndex
  } = useContext(SegmentedControlContext);
  const {
    isMobile
  } = useBreakpoint();
  const handleItemClick = () => {
    onItemClick?.(index);
    setActiveItemIndex?.(index);
  };
  const desktopSize = typeof size === 'object' ? size.desktop || 'm' : size || 'm';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 'm';
  return <SegmentedControlItemWrapper desktopSize={desktopSize} mobileSize={mobileSize} onClick={handleItemClick} {...rest}>
      {icon && <IconWrapper desktopSize={desktopSize} mobileSize={mobileSize}>
          {icon}
        </IconWrapper>}
      <Text family="MTSWide" size={getSegmentedControlItemTextSize(isMobile ? mobileSize : desktopSize, Boolean(icon))} weight="medium">
        {label}
      </Text>
      {!isLastElem && index + 1 !== activeItemIndex && <Divider />}
    </SegmentedControlItemWrapper>;
};
export default SegmentedControlItem;
interface SegmentedControlItemWrapperProps {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
}
const _exp = /*#__PURE__*/() => ({
  desktopSize
}) => segmentedControlItemHeightRem[desktopSize];
const _exp2 = /*#__PURE__*/() => ({
  desktopSize
}) => segmentedControlItemBorderRadiusesRem[desktopSize];
const _exp3 = /*#__PURE__*/() => ({
  mobileSize
}) => segmentedControlItemHeightPx[mobileSize];
const _exp4 = /*#__PURE__*/() => ({
  mobileSize
}) => segmentedControlItemBorderRadiusesPx[mobileSize];
const SegmentedControlItemWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "SegmentedControlItemWrapper",
  class: "s1tukx2n",
  propsAsIs: false,
  vars: {
    "s1tukx2n-0": [_exp()],
    "s1tukx2n-1": [_exp2()],
    "s1tukx2n-2": [_exp3()],
    "s1tukx2n-3": [_exp4()]
  }
}));
interface IconWrapperProps {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
}
const _exp6 = /*#__PURE__*/() => ({
  desktopSize
}) => segmentedControlItemIconWrapperSizesRem[desktopSize];
const _exp8 = /*#__PURE__*/() => ({
  desktopSize
}) => segmentedControlItemIconSizesRem[desktopSize];
const _exp0 = /*#__PURE__*/() => ({
  mobileSize
}) => segmentedControlItemIconWrapperSizesPx[mobileSize];
const _exp10 = /*#__PURE__*/() => ({
  mobileSize
}) => segmentedControlItemIconSizesPx[mobileSize];
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "iwe8awq",
  propsAsIs: false,
  vars: {
    "iwe8awq-0": [_exp6()],
    "iwe8awq-1": [_exp8()],
    "iwe8awq-2": [_exp0()],
    "iwe8awq-3": [_exp10()]
  }
});
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const Divider = withTheme(/*#__PURE__*/styled('div')({
  name: "Divider",
  class: "d1gwicog",
  propsAsIs: false,
  vars: {
    "d1gwicog-0": [_exp11()]
  }
}));

require("./SegmentedControlItem.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SegmentedControlItem.tsx");